module.exports = {
  choose_metric: 'Select metric',
  choose_condition: 'Select condition',
  filter_placeholder: 'Start entering the metric value ...'
}
